/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserGroup } from './UserGroup';
import {
    UserGroupFromJSON,
    UserGroupFromJSONTyped,
    UserGroupToJSON,
} from './UserGroup';

/**
 * 
 * @export
 * @interface CreateUserGroup201Response
 */
export interface CreateUserGroup201Response {
    /**
     * 
     * @type {UserGroup}
     * @memberof CreateUserGroup201Response
     */
    data?: UserGroup;
}

/**
 * Check if a given object implements the CreateUserGroup201Response interface.
 */
export function instanceOfCreateUserGroup201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateUserGroup201ResponseFromJSON(json: any): CreateUserGroup201Response {
    return CreateUserGroup201ResponseFromJSONTyped(json, false);
}

export function CreateUserGroup201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserGroup201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UserGroupFromJSON(json['data']),
    };
}

export function CreateUserGroup201ResponseToJSON(value?: CreateUserGroup201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UserGroupToJSON(value.data),
    };
}

